import { Box, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CoachDossier } from "../../api/client";

const FIELDS: { key: keyof CoachDossier; labelKey: string }[] = [
  { key: "professional_profile", labelKey: "DossierRail.professionalProfileLabel" },
  { key: "target_role", labelKey: "DossierRail.targetRoleLabel" },
  { key: "constraints_profile", labelKey: "DossierRail.constraintsLabel" },
  { key: "market_intel", labelKey: "DossierRail.marketIntelLabel" },
  { key: "gap_analysis", labelKey: "DossierRail.gapAnalysisLabel" },
  { key: "action_plan", labelKey: "DossierRail.actionPlanLabel" },
];

function renderValue(value: Record<string, any>): string {
  return Object.entries(value)
    .map(([k, v]) => `${k.replace(/_/g, " ")}: ${Array.isArray(v) ? v.join(", ") : v}`)
    .join(" · ");
}

export default function DossierRail({ dossier }: { dossier: CoachDossier | null }) {
  const { t } = useTranslation("coach");
  const filled = FIELDS.filter((f) => dossier && dossier[f.key]);

  return (
    <Paper elevation={0} sx={{ border: 1, borderColor: "divider", borderRadius: 3, p: 2.5 }}>
      <Typography variant="subtitle2" fontWeight={500} gutterBottom>
        {t("DossierRail.title")}
      </Typography>
      {filled.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          {t("DossierRail.emptyMessage")}
        </Typography>
      ) : (
        <Stack spacing={1.5} mt={1}>
          {filled.map((f) => (
            <Box key={String(f.key)}>
              <Typography variant="caption" fontWeight={500} color="text.secondary">
                {t(f.labelKey)}
              </Typography>
              <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                {renderValue(dossier![f.key] as Record<string, any>)}
              </Typography>
            </Box>
          ))}
        </Stack>
      )}
    </Paper>
  );
}
